export function formatDate(dateString: string): string {
    const date = new Date(dateString);

    return date.toLocaleDateString("fa-IR", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
}

export function formatTime(dateString: string): string {
    const date = new Date(dateString);

    return date.toLocaleTimeString("fa-IR", {
        hour: "2-digit",
        minute: "2-digit"
    });
}
